module.exports = __webpack_public_path__ + "img/partner-6-light.704d604c.png";